import React from 'react'
import Header from './Header'
import Footer from './Footer'
import { Outlet } from 'react-router-dom'
import { Box } from '@mui/material'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import { useMediaQueries } from '../../usecontext/UseProvider'

const Layout = () => {
  const { wpNumber } = useMediaQueries();

  const handleWhatsAppClick = () => {
    const whatsappURL = `https://wa.me/${wpNumber}`;
    window.open(whatsappURL, "_blank");
  };

  return (
    <>
      <Header />
      <Box sx={{ mt: '80px', position: 'relative' }}>
        <Outlet />
        {/* WhatsApp Icon */}
        <WhatsAppIcon
          sx={{
            backgroundColor: '#35CC35',
            color: '#fff',
            height: '40px',
            width: '40px',
            borderRadius: '50%',
            p: 0.5,
            zIndex: '11',
            position: 'fixed',
            bottom: '5%',
            right: { sm: '30px', xs: '10px' },
            cursor: 'pointer',
            boxShadow: '0 4px 6px rgba(0, 0, 0, 0.2)',
          }}
          onClick={handleWhatsAppClick}
        />
      </Box>
      <Footer />
    </>
  )
}

export default Layout